import io from 'socket.io-client';
import { SOCKET_CHAT_EVENT } from 'constants/constants';
import { TEMP_USER_TOKEN, USER_TOKEN } from './storage';

export default class Socket {
  constructor(host) {
    this.host = host;
  }

  connect(params = {}) {
    const host = this.host;
    const socket = io.connect(host, { transports: ['websocket'] });
    this.socket = socket;
    this.authenticate(socket, params);
  }

  authenticate(socket, params = {}) {
    socket.on('connect', async () => {
      await this.sendAuthenticate(socket, params);
      socket.on('unauthorized', () => {
        socket.disconnect();
      });
    });
  }

  userStateChange(param = {}) {
    this.socket.emit(SOCKET_CHAT_EVENT.USER_ONLINE_STATE_CHANGE, param);
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  /**
   * Send authentication to server
   */
  async sendAuthenticate(socket, params = {}) {
    const tempToken = TEMP_USER_TOKEN.get();
    const token = await USER_TOKEN.get();
    if (socket?.connected === true && token) {
      const authData = {
        token: tempToken || token,
        ...(tempToken && { adminToken: token }),
        ...params,
      };
      socket.emit('authentication', authData);
    }
  }

  /**
   * Listen an event
   * @param event
   * @param cb
   */
  on(event, cb) {
    const socket = this.socket;
    socket?.on(event, cb);
  }

  /**
   * Remove event listener
   * @param event
   * @param cb
   */

  off(event, cb) {
    const socket = this.socket;
    socket?.off(event, cb);
  }
}
